import FirstPageHeader from './components/FirstPageHeader'
import FirstPageFooter from './components/FirstPageFooter'
import FirstPageLogo from './components/FirstPageLogo'
import ResultsPageBody from './components/ResultsPageBody'
import ResultsPageFooter from './components/ResultsPageFooter'
import ResultsPageHeader from './components/ResultsPageHeader'
import Search from './components/Search'
import Read from './components/Read'
import About from './components/About'
import Privacy from './components/Privacy'
import PrivacyHeader from './components/PrivacyHeader'
import MobileApp from './components/MobileApp'
import {BrowserRouter as Router, Route} from 'react-router-dom'

function App() {
  

  return (
      <Router>
        <Route path="/" exact render={(props) =>(
          <div className="App">
            <FirstPageHeader />
            <FirstPageLogo />
            <Search  searchHeight="50px" searchContWidth="460px" searchInputWidth="400px" />        
            <FirstPageFooter />
            
          </div>
        )}/>
        
        <Route path="/wiki/:searchValueFromUrl" exact render={(props) =>{ 
          const {searchValueFromUrl} = props.match.params
          return(
          <div className="App">
            <ResultsPageHeader />
              <div className="resultspage-searchresults-cont">
                <Search searchHeight="40px" searchContWidth="590px" searchInputWidth="530px" />
              </div>
            <ResultsPageBody resValFromUrl={searchValueFromUrl} /> 
            <ResultsPageFooter />
          </div>
          )  
        }}/>


        <Route path="/read/:readValueFromUrl" exact render={(props) =>{ 
          const {readValueFromUrl} = props.match.params
          return(
          <div className="App">
             <ResultsPageHeader />
              <div className="resultspage-searchresults-cont">
                <Search searchHeight="40px" searchContWidth="590px" searchInputWidth="530px" />
              </div>
            <Read readVal={readValueFromUrl} />
            <ResultsPageFooter />
          </div>
          )  
        }}/>


        <Route path="/mobileapp" exact render={(props) =>{
          return(
            <div className="App">
              <MobileApp />
            </div>
            )
        }}/>

        <Route path="/privacy" exact render={(props) =>{
          return(
            <div className="App">
              <PrivacyHeader />
              <Privacy />
              <ResultsPageFooter />
            </div>
            )
        }}/>

        <Route path="/about" exact render={(props) =>{
          return(
            <div className="App">
              <PrivacyHeader />
              <About />
              <ResultsPageFooter />
            </div>
            )
        }}/>
      
      </Router>
  );
}

export default App;
